import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    tooltip: {
        position: 'absolute',
        backgroundColor: '#fff',
        border: '2px solid #000',
        color: '#000',
        padding: '8px 12px',
        fontSize: 12,
        zIndex: 2,
        whiteSpace: 'nowrap',
        userSelect: 'none',
        boxShadow: '1px 4px 8px -5px rgba(0, 0, 0, 0.2)',
        '&::after': {
            content: '""',
            position: 'absolute',
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: '12px 12px 0 12px', // Arrow size
            borderColor: '#333 transparent transparent transparent',
            top: '-12px',
            left: '20%',
            transform: 'translateX(-50%) rotate(180deg)',
        },
    },
});

export default function Tooltip({ children, targetRef }) {
    const classes = useStyles();
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        if (targetRef.current) {
            const rect = targetRef.current.getBoundingClientRect();
            setCoords({
                top: rect.bottom + window.scrollY, // Above target
                left: rect.left,
            });
        }

        const handleClick = () => setVisible(false);
        document.addEventListener('click', handleClick);
        document.addEventListener('touchstart', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('touchstart', handleClick);
        };
    }, [targetRef]);

    if (!visible) return null;

    return (
        <div
            className={classes.tooltip}
            style={{ top: coords.top, left: coords.left, position: 'absolute' }}
        >
            {children}
        </div>
    );
}
